export default __webpack_public_path__ + "static/1-87c02972f868d10576b5c1dc7971c089.png";